<template>
  <section>
    <div class="card">
      <div class="card-inner">
        <p class="card-title"> Défi(s) en cours</p>
        <div
          v-if="in_progress_challenges.length > 0 && !isAdmin"
          style="text-align: center"
        >
          <div
            v-for="(chall, index) in  in_progress_challenges"
            class="challenge-container"
            :key="index"
          >
            <div class="versus-block">
              <span><strong>{{getWeezyName(chall.weezy1_id)}}</strong></span> VS <span><strong>{{getWeezyName(chall.weezy2_id)}}</strong></span>
            </div>
            <div>
              <div id="myProgress">
                <div
                  id="myBar"
                  :style="'width:' + chall.percent_1/2 + '%'"
                ><span style="color: white">{{chall.percent_1}}%</span></div>
                <div
                  id="mySecondBar"
                  :style="'width:' + chall.percent_2/2 + '%'"
                ><span style="color: white">{{chall.percent_2}}%</span></div>
              </div>
            </div>
            <div
              class="challenge-result"
              v-if="(chall.percent_1 > 0 || chall.percent_2 > 0) && !chall.is_finished"
            >
              <span v-if="chall.percent_1 > chall.percent_2">L'équipe <strong>{{getWeezyName(chall.weezy1_id)}}</strong> est en tête !</span>
              <span v-else-if="chall.percent_1 < chall.percent_2">L'équipe <strong>{{getWeezyName(chall.weezy2_id)}}</strong> est en tête !</span>
              <span v-else>Les deux équipes sont à égalité !</span>
            </div>
            <div
              class="challenge-result"
              v-if="(chall.percent_1 > 0 || chall.percent_2 > 0) && chall.is_finished"
            >
              <span v-if="chall.percent_1 > chall.percent_2">L'équipe <strong>{{getWeezyName(chall.weezy1_id)}}</strong> remporte le défi !</span>
              <span v-else-if="chall.percent_1 < chall.percent_2">L'équipe <strong>{{getWeezyName(chall.weezy2_id)}}</strong> remporte le défi !</span>
              <span v-else>Les deux équipes sont ont fini à égalité !</span>
            </div>
            <button
              class="button field is-danger is-medium"
              id="clear"
              @click="cancelChallenge(chall.id)"
            >
              <span>Annuler</span>
            </button>
          </div>
        </div>

        <div style="margin-left: 25px; margin-right: 25px; margin-top: 25px; ">
          <b-loading
            :is-full-page="false"
            :active.sync="isLoading"
            :can-cancel="true"
          ></b-loading>
        </div>
      </div>
    </div>
  </section>
</template>



<script>
import http from "@/modules/request";

export default {
  name: "inProgressChallenges",
  props: ["in_progress_challenges", "weezys", "isAdmin"],

  data: () => {
    return {
      isEmpty: false,
      isLoading: false
    };
  },
  methods: {
    cancelChallenge(challenge_id) {
      http
        .patch(`/challenges/${challenge_id}/cancel`)
        .then(res => {
          this.$parent.getChallenges();
        })
        .catch(error => {
          console.log(error);
          this.errored = true;
          if (error.response.status === 401) {
            console.log("unauthorized, logging out ...");
          }
        });
    },

    getWeezyName(fromWeezyId) {
      for (var i = 0; i < this.weezys.length; i++) {
        if (fromWeezyId == this.weezys[i].id) {
          return this.weezys[i].name;
        }
      }
    },
    errorToast(message) {
      this.$parent.$toast.open({
        duration: 5000,
        message: message,
        position: "is-bottom",
        type: "is-danger"
      });
    },
    succesToast(message) {
      this.$parent.$toast.open({
        duration: 2000,
        message: message,
        position: "is-bottom",
        type: "is-success"
      });
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>